import { render, staticRenderFns } from "./ModalSyncOrderChannel.vue?vue&type=template&id=35cc8bcd&"
import script from "./ModalSyncOrderChannel.vue?vue&type=script&lang=js&"
export * from "./ModalSyncOrderChannel.vue?vue&type=script&lang=js&"
import style0 from "./ModalSyncOrderChannel.vue?vue&type=style&index=0&id=35cc8bcd&prod&lang=scss&module=true&"
import style1 from "./ModalSyncOrderChannel.vue?vue&type=style&index=1&id=35cc8bcd&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports